import { LogRepository } from "@domain/repositories/LogRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";
import { Log } from "@domain/models/Log";

type Input = Client["id"];

type Output = Promise<Log[]>;

export class GetClientLogsUseCase implements UseCase<Input, Output> {
  constructor(private readonly logRepository: LogRepository) {}

  async execute(clientId: Input) {
    return this.logRepository.getClientLogs(clientId);
  }
}
